function getUsedSampleAliases (projectId) {
  if (!this.samples) return
  if (!projectId) return
  return Object.values(this.samples).filter(sample => sample.projectId === projectId).map(sample => sample.alias)
}

export default getUsedSampleAliases